import { useInstance } from 'intact-react';
import dayjs from '../datepicker/dayjs';
import { YEAR_FORMAT, TIME_FORMAT, PREFIX } from './constants';
export function useFormats() {
  var instance = useInstance();
  function getValueFormat() {
    var _instance$get = instance.get(),
      format = _instance$get.format,
      valueFormat = _instance$get.valueFormat;
    return valueFormat || format || TIME_FORMAT;
  }
  function getShowFormat() {
    var _instance$get2 = instance.get(),
      format = _instance$get2.format,
      showFormat = _instance$get2.showFormat;
    return showFormat || format || TIME_FORMAT;
  }
  function createDateByValueFormat(value) {
    return dayjs(PREFIX + value, YEAR_FORMAT + getValueFormat());
  }
  function createDateByShowFormat(value) {
    return dayjs(PREFIX + value, YEAR_FORMAT + getShowFormat(), true); // strict parsing 
  }
  function getShowString(value) {
    return value.format(getShowFormat());
  }
  function getValueString(value) {
    return value.format(getValueFormat());
  }
  return {
    getValueFormat: getValueFormat,
    getShowFormat: getShowFormat,
    createDateByValueFormat: createDateByValueFormat,
    createDateByShowFormat: createDateByShowFormat,
    getShowString: getShowString,
    getValueString: getValueString
  };
}